import gql from 'graphql-tag';

export const GET_CAMPAIGN_IDS_WITH_UNACKNOWLEDGED_NOTIFICATION = gql`
  query GET_CAMPAIGN_IDS_WITH_UNACKNOWLEDGED_NOTIFICATION($campaignsIds: [String!]!) {
    getCampaignIdsWithUnacknowledgedNotifications(idList: $campaignsIds)
  }
`;
